import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconLookingForJob = memo(({ color, size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" {...rest}>
      <Path
        fill={color}
        d="M12 0c1.11 0 2 .89 2 2v2h4c1.11 0 2 .89 2 2v11a2 2 0 01-.106.647l-1.977-1.98h-.659l-.233-.225a5.392 5.392 0 001.308-3.525 5.416 5.416 0 10-5.416 5.416 5.392 5.392 0 003.525-1.308l.225.233v.659l1.98 1.977A2 2 0 0118 19H2c-1.11 0-2-.89-2-2L.01 6C.01 4.89.89 4 2 4h4V2c0-1.11.89-2 2-2zm.917 8.167c2.075 0 3.75 1.675 3.75 3.75s-1.675 3.75-3.75 3.75-3.75-1.675-3.75-3.75 1.675-3.75 3.75-3.75zM12 2H8v2h4V2z"
      />
    </Svg>
  );
});